export const defaultTextAreaStyleOptions = {
	padding: '4px 8px',
	fontSize: '12px',
	lineHeight: '1.4',
	fontFamily: 'sans-serif',
	border: 'none',
	borderRadius: '0',
	background: 'rgba(255,255,255,0.95)',
	color: '#111',
	margin: '0',
	display: 'block',
	resize: 'none',
	outline: 'none',
	overflowY: 'hidden',
	width: 'auto',
	flex: '1',
	boxSizing: 'border-box',
	position: 'relative'
} as CSSStyleDeclaration;

export const defaultSubmitButtonStyleOptions = {
	padding: '6px 10px',
	fontSize: '11px',
	fontFamily: 'sans-serif',
	backgroundColor: '#3F97E0',
	border: '1px solid #d9d9d9',
	borderTop: 'none',
	borderRight: 'none',
	borderBottom: 'none',
	borderRadius: '0',
	cursor: 'pointer',
	minWidth: '48px',
	minHeight: '25px',
	boxSizing: 'border-box',
	position: 'relative'
} as CSSStyleDeclaration;

export const defaultTextAreaWrapperStyleOptions = {
	position: 'absolute',
	zIndex: '1000',
	display: 'flex',
	flexDirection: 'column',
	minWidth: '210px',
	maxWidth: '250px',
	border: '1px solid #d9d9d9',
	boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
	borderRadius: '0',
	overflow: 'hidden',
	background: 'rgba(255,255,255,1.0)'
} as CSSStyleDeclaration;

export const defaultTextAreaTooltipSpanStyleOptions = {
	display: 'block',
	padding: '4px 8px',
	fontSize: '10px',
	fontFamily: 'sans-serif',
	color: '#888',
	background: 'rgba(255,255,255,0.95)',
	borderTop: '1px solid #d9d9d9'
} as CSSStyleDeclaration;
